import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { ProjectTermGetList } from "../../services/ReduxTookit/Slice/ProjectTermRedux";
import Nodata from "../../component/common-component/Nodata";
import {
  NotificationSettingGetList,
  NotificationSettingSave,
} from "../../services/ReduxTookit/Slice/NotificationSetting";
import Loader, { LoaderType } from "../../component/common-component/Loader";

const NotificationsManagementModel = () => {
  const dispatch = useDispatch();
  const [notificationList, setNotificationList] = useState({});

  const [savedNotificationList, setSavedNotificationList] = useState(null);
  const savedNotificationListRef = useRef();
  savedNotificationListRef.current = savedNotificationList;
  const [loading, setLoading] = useState(true);

  const getProjectTermList = async () => {
    let body = {
      term: "",
      category: "Notification",
    };
    dispatch(ProjectTermGetList(body))
      ?.then((response) => {
        if (response?.payload?.isValidate) {
          let groupingJson = {};
          response?.payload?.data?.data?.forEach((item) => {
            if (groupingJson[item?.subcategory]) {
              groupingJson?.[item?.subcategory]?.push(item);
            } else {
              groupingJson[item?.subcategory] = [item];
            }
          });
          setNotificationList(groupingJson);
        } else {
          setNotificationList(null);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getSavedNotificationList = async () => {
    dispatch(NotificationSettingGetList()).then((res) => {
      if (res?.payload?.isValidate) {
        setSavedNotificationList(res?.payload?.data?.data?.dataList1);
      } else {
        setSavedNotificationList(null);
      }
    });
  };

  useEffect(() => {
    getSavedNotificationList();
    getProjectTermList();
  }, []);

  const saveNotificationSetting = async (body) => {
    dispatch(NotificationSettingSave(body)).then((res) => {
      if (res?.payload?.isValidate) {
        let newData = {
          notificationsettingid:
            res?.payload?.data?.data?.notificationsettingid,
          notificationsettingtitle:
            res?.payload?.data?.data?.notificationsettingtitle,
          isaccept: res?.payload?.data?.data?.isaccept,
        };
        let updatedData = savedNotificationListRef.current?.map((item) => {
          if (
            item?.notificationsettingtitle === newData?.notificationsettingtitle
          ) {
            item.notificationsettingid = newData?.notificationsettingid;
          }
          return item;
        });
        setSavedNotificationList(updatedData);
      } else {
        let finalData = savedNotificationListRef.current?.filter(
          (x) => x?.notificationsettingtitle != body?.notificationsettingtitle
        );
        setSavedNotificationList(finalData);
      }
    });
  };

  const checkSingleChecked = (title) => {
    let isSaved = false,
      id = 0;
    const isTitleExists = savedNotificationList?.filter(
      (x) => x?.notificationsettingtitle === title
    );
    if (isTitleExists?.length > 0) {
      isSaved = isTitleExists?.[0]?.isaccept
        ? isTitleExists?.[0]?.isaccept
        : false;
      id = isTitleExists?.[0]?.notificationsettingid;
    }

    return { isSaved, id };
  };
  const checkAllChecked = (value) => {
    if (!savedNotificationList) return false;

    return value.every((item) =>
      savedNotificationList.some(
        (x) => x.notificationsettingtitle === item.term && x.isaccept
      )
    );
  };

  // const checkAllChecked = (value) => {
  //   let notCheckedArr = [];

  //   value?.forEach((item) => {
  //     let dataExists = savedNotificationList?.filter(
  //       (x) => x?.notificationsettingtitle === item?.term
  //     );

  //     if (dataExists?.length > 0) {
  //       if (!dataExists?.[0]?.isaccept) {
  //         notCheckedArr.push("false");
  //       }
  //     } else {
  //       notCheckedArr.push("false");
  //     }
  //   });

  //   return notCheckedArr?.length > 0 ? false : true;
  // };

  // const calledAllApi = (value, checkValue) => {
  //   value?.forEach((item) => {
  //     const isChecked = checkSingleChecked(item?.term);
  //     let body = {
  //       notificationsettingid: isChecked?.id,
  //       notificationsettingtitle: item?.term,
  //       isaccept: checkValue,
  //     };

  //     if (savedNotificationList) {
  //       if (isChecked?.id > 0) {
  //         let data = [...savedNotificationList];
  //         let updatedData = data?.map((saveItem) => {
  //           if (saveItem?.notificationsettingtitle === item?.term) {
  //             saveItem.isaccept = checkValue;
  //           }
  //           return saveItem;
  //         });
  //         setSavedNotificationList(updatedData);
  //         savedNotificationListRef.current = updatedData;
  //       } else {
  //         setSavedNotificationList((prev) => [
  //           ...prev,
  //           {
  //             notificationsettingid: isChecked?.id,
  //             notificationsettingtitle: item?.term,
  //             isaccept: checkValue,
  //           },
  //         ]);
  //         savedNotificationListRef.current = [
  //           ...savedNotificationListRef.current,
  //           {
  //             notificationsettingid: isChecked?.id,
  //             notificationsettingtitle: item?.term,
  //             isaccept: checkValue,
  //           },
  //         ];
  //       }
  //     } else {
  //       setSavedNotificationList([
  //         {
  //           notificationsettingid: isChecked?.id,
  //           notificationsettingtitle: item?.term,
  //           isaccept: checkValue,
  //         },
  //       ]);
  //       savedNotificationListRef.current = [
  //         {
  //           notificationsettingid: isChecked?.id,
  //           notificationsettingtitle: item?.term,
  //           isaccept: checkValue,
  //         },
  //       ];
  //     }

  //     saveNotificationSetting(body);
  //   });
  // };

  const calledAllApi = (value, checkValue) => {
    let updatedSavedList = [...(savedNotificationListRef.current || [])];

    value.forEach((item) => {
      const isChecked = checkSingleChecked(item?.term);

      let body = {
        notificationsettingid: isChecked?.id,
        notificationsettingtitle: item?.term,
        isaccept: checkValue,
      };

      if (isChecked?.id > 0) {
        updatedSavedList = updatedSavedList.map((saveItem) =>
          saveItem.notificationsettingtitle === item?.term
            ? { ...saveItem, isaccept: checkValue }
            : saveItem
        );
      } else {
        updatedSavedList.push({
          notificationsettingid: isChecked?.id,
          notificationsettingtitle: item?.term,
          isaccept: checkValue,
        });
      }

      saveNotificationSetting(body);
    });

    setSavedNotificationList(updatedSavedList);
    savedNotificationListRef.current = updatedSavedList;
  };

  if (Object.keys(notificationList).length === 0) {
    return <Loader type={LoaderType.NotificationSetting} count={2} />;
  }
  return (
    <>
      <div className="main-notification-page">
        <div className="main-notification-page-contain">
          {loading ? (
            <Loader type={LoaderType.NotificationSetting} count={2} />
          ) : notificationList ? (
            Object?.entries(notificationList)?.map(([key, value]) => {
              const isAllChecked = checkAllChecked(value);
              return (
                <>
                  <div className="profile-common-title" key={key}>
                    <h3>{key}</h3>
                  </div>
                  <div className="profile-common">
                    <div className="checkbox-list-in-modal">
                      <div className="account-activity">
                        <div className="activity-one">
                          <Form.Check
                            className="notification-select"
                            type="checkbox"
                            id={key}
                            label="Select All"
                            checked={isAllChecked}
                            onChange={(e) => {
                              calledAllApi(value, e.target.checked);
                            }}
                          />
                        </div>
                        {value?.map((item) => {
                          const isChecked = checkSingleChecked(item?.term);
                          return (
                            <div
                              className="activity-one"
                              key={item?.projecttermid}
                            >
                              {/* <Form.Check
                                type="checkbox"
                                id={`${key}-${item?.term}`}
                                label={item?.term}
                                checked={isChecked?.isSaved}
                                onChange={(e) => {
                                  if (savedNotificationList) {
                                    if (isChecked?.id > 0) {
                                      let data = [...savedNotificationList];
                                      let updatedData = data?.map(
                                        (saveItem) => {
                                          if (
                                            saveItem?.notificationsettingtitle ===
                                            item?.term
                                          ) {
                                            saveItem.isaccept =
                                              e.target.checked;
                                          }
                                          return saveItem;
                                        }
                                      );
                                      setSavedNotificationList(updatedData);
                                      savedNotificationListRef.current =
                                        updatedData;
                                    } else {
                                      setSavedNotificationList((prev) => [
                                        ...prev,
                                        {
                                          notificationsettingid: isChecked?.id,
                                          notificationsettingtitle: item?.term,
                                          isaccept: e.target.checked,
                                        },
                                      ]);
                                      savedNotificationListRef.current = [
                                        ...savedNotificationListRef.current,
                                        {
                                          notificationsettingid: isChecked?.id,
                                          notificationsettingtitle: item?.term,
                                          isaccept: e.target.checked,
                                        },
                                      ];
                                    }
                                  } else {
                                    setSavedNotificationList([
                                      {
                                        notificationsettingid: isChecked?.id,
                                        notificationsettingtitle: item?.term,
                                        isaccept: e.target.checked,
                                      },
                                    ]);
                                    savedNotificationListRef.current = [
                                      {
                                        notificationsettingid: isChecked?.id,
                                        notificationsettingtitle: item?.term,
                                        isaccept: e.target.checked,
                                      },
                                    ];
                                  }
                                  let body = {
                                    notificationsettingid: isChecked?.id,
                                    notificationsettingtitle: item?.term,
                                    isaccept: e.target.checked,
                                  };
                                  saveNotificationSetting(body);
                                }}
                              /> */}
                              <Form.Check
                                type="checkbox"
                                id={`${key}-${item?.term}`}
                                label={item?.term}
                                checked={isChecked?.isSaved}
                                onChange={(e) => {
                                  let updatedData = [
                                    ...(savedNotificationListRef.current || []),
                                  ];

                                  const existingIndex = updatedData.findIndex(
                                    (x) =>
                                      x.notificationsettingtitle === item.term
                                  );

                                  if (existingIndex !== -1) {
                                    updatedData[existingIndex].isaccept =
                                      e.target.checked;
                                  } else {
                                    updatedData.push({
                                      notificationsettingid: isChecked?.id,
                                      notificationsettingtitle: item?.term,
                                      isaccept: e.target.checked,
                                    });
                                  }

                                  setSavedNotificationList(updatedData);
                                  savedNotificationListRef.current =
                                    updatedData;

                                  saveNotificationSetting({
                                    notificationsettingid: isChecked?.id,
                                    notificationsettingtitle: item?.term,
                                    isaccept: e.target.checked,
                                  });
                                }}
                              />

                              <p>{item?.details}</p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <Nodata />
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationsManagementModel;
